import React from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import { TYPE } from '../../utils/constants/userManagementConstant';

const dropdownStyle = {
    control: (provided, state) => {
        const { selectProps: { hasError }, isDisabled } = state;
        return {
            ...provided,
            backgroundColor: isDisabled ? "#999" : "#ffffff",
            borderRadius: 5,
            height: 48,
            borderWidth: 1,
            borderColor: hasError ? "#CD3500" : "#C5C1C8"
        };
    },
    singleValue: (provided) => ({
        ...provided,
        backgroundColor: "transparent",
        color: "#100045",
        fontFamily: "VodafoneRg-Regular",
        fontSize: 13
    }),
    placeholder: (provided) => ({
        ...provided,
        backgroundColor: "transparent",
        color: "#837B8B",
        fontFamily: "VodafoneRg-Regular",
        fontSize: 16
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        backgroundColor: "transparent",
        width: 0
    }),
    container: (provided, state) => {
        const { selectProps: { customStyles } } = state;
        return {
            ...provided,
            ...customStyles
        };
    },
    menuList: (provided) => ({
        ...provided,
        maxHeight: 200,
        overflowY: 'auto',
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        paddingBottom: 4,
        paddingTop: 4,
        boxSizing: 'border-box'
    }),
    valueContainer: (provided) => ({
        ...provided,
        flexWrap: 'nowrap',
        overflowX: 'auto',
        maxWidth: '100%'
    }),
    MultiValueRemove:(provided) =>({
        ...provided,
        display:"none",
    }),
    option: (provided, state) => ({
        ...provided,
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        backgroundColor: state.isSelected ? "#FFF2F2" : state.isFocused ? "#FFF2F2" : "transparent",
        color:state.isSelected?"inherit":"",
        padding: "8px 12px",
        boxSizing: "border-box",
        // borderBottom: "1px solid #EBEBEB",
        position: "relative",
        "&::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: "10%",
            width: "80%",
            borderBottom: "1px solid #EBEBEB"
        },

        "&:hover": {
            backgroundColor: "#FFE3E3",
            // color: "hsl(0, 0%, 100%)"
        }
    })
};

const defaultCustomStyles = {
    width: "auto"
};
const CustomGroupHeading = (props) => (
    <div
        style={{
            padding: "8px 12px",
            background: "#CCCCCC",
            fontWeight: 700,
            color: "#333333",
            borderBottom: "1px solid #EBEBEB"
        }}
    >
        {props.children}
    </div>
);

// const CustomOption = (props) => {
//     return (
//         <components.Option {...props}>
//             <input
//                 type="checkbox"
//                 checked={props.isSelected}
//                 onChange={() => null}
//                 style={{ marginRight: 8 }}
//             />
//             <label>{props.label}</label>
//         </components.Option>
//     );
// };

const CustomOption = (props) => {
    const { filterType } = props.selectProps;
    return (
        <components.Option {...props}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 11fr' }}>
            <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => null}
                style={{ 
                    marginRight: 8,
                    appearance: "none",
                    width: 16,
                    height: 16,
                    border: "1px solid #C5C1C8",
                    borderRadius: 3,
                    backgroundColor: props.isSelected ? "#CCCCCC" : "transparent",
                    position: "relative",
                    margin:'5px 5px auto 0'
                }}
            />
            {props.isSelected && (
                <span style={{
                    position: "absolute",
                    // top: 14,
                    // left: 0,
                    width: 16,
                    height: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#333333",
                    fontSize: 13,
                    marginTop:5,
                    marginLeft:0
                }}>
                    ✓
                </span>
            )}
            <label style={{ color: props.isSelected ? "#333333" : "inherit", wordBreak:"break-all"}}>{props.label}</label> {/* Change label color */}
            </div>
            {/* {filterType && <label style={{fontFamily: 'VodafoneRg-Regular',fontWeight: 400,color: '#333333',fontSize: '14px',textDecoration: 'underline', paddingLeft:"21px"}}>{TYPE[props.data?.type]}</label>} */}
        </components.Option>
    );
};
const CustomMultiValueRemove = () => null;
const CustomDropdownIndicator = () => null;
const CustomClearIndicator = () => null;

const DropDown = ({ options, placeholder, onChange, value, hasError, customStyles = defaultCustomStyles, menuIsOpen,filterType=null }) => {
    const formattedOptions =
        filterType === "serviceType"
            ? [
                {
                label: TYPE.ipx_service,
                options: options.filter(item => TYPE[item?.type] === TYPE.ipx_service)
                },
                {
                label: TYPE.ivc_service,
                options: options.filter(item => TYPE[item?.type] === TYPE.ivc_service)
                }
            ]
            : options;
    const customDropdownStyle = {
        ...dropdownStyle,
        ...(filterType === "serviceType" && {
            group: (provided) => ({...provided,paddingTop: 0,paddingBottom: 0,}),
            groupHeading: (provided) => ({...provided,marginBottom: 0,paddingBottom: 0,}),}),
    };
    return (
        <Select
            placeholder={placeholder}
            options={formattedOptions}
            isMulti={true}
            onChange={onChange}
            styles={customDropdownStyle}
            hasError={hasError}
            value={value}
            customStyles={customStyles}
            menuIsOpen={menuIsOpen}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            filterType={filterType}
            components={{
                Option: CustomOption,
                ...(filterType === "serviceType" ? { GroupHeading: CustomGroupHeading }: {}),
                MultiValueRemove: CustomMultiValueRemove,
                DropdownIndicator: CustomDropdownIndicator,
                ClearIndicator: CustomClearIndicator,
            }}
        />
    );
};

DropDown.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired
    })).isRequired,
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.array,
    hasError: PropTypes.bool,
    customStyles: PropTypes.object,
    menuIsOpen: PropTypes.bool
};

DropDown.defaultProps = {
    placeholder: "Select",
    value: [],
    hasError: false,
    customStyles: defaultCustomStyles,
    menuIsOpen: false
};

export default DropDown;